import React from 'react'
import { useField, FieldRenderProps } from 'react-final-form'

import { FieldSubscription } from 'final-form'

type FieldObservableType<T extends any> = {
    name: string
    subscription?: FieldSubscription
    children: (field: FieldRenderProps<T>) => React.ReactNode | void
}

const FieldObservable = <T extends any>({
    children,
    name,
    subscription,
}: FieldObservableType<T>): React.ReactElement => {
    const field = useField<T>(name, { subscription })
    return <>{children(field)}</>
}

export default FieldObservable
